import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui, greyMui, rydeColors } from "@ryde/theme";

export const MobileHeaderStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "mobile-header",
})<{ $isAdminApp: boolean }>`
  grid-area: mobile_header;
  background-color: ${({ $isAdminApp }) =>
    $isAdminApp ? greyMui._900 : deepPurpleMui._900};
  display: flex;
  align-items: center;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  .MobileHeader-Title {
    flex: 1;
    min-width: 0;
    font-weight: 400;
    font-size: 24px;
    margin-inline-start: 16px;
    color: white;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .MobileHeader-Actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 2px;
    margin-inline-start: auto;
    color: ${rydeColors.white};
  }
  .MobileHeader-History,
  .MobileHeader-Notifications {
    color: inherit;
  }
  .MobileHeader-History .MuiSvgIcon-root,
  .MobileHeader-Notifications .MuiSvgIcon-root {
    color: inherit;
  }
  .MobileHeader-CompanySwitch {
    color: ${rydeColors.white};
  }
  .MobileHeader-CompanySwitch svg circle {
    fill: currentColor;
  }
`;
